"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
var common_impl_1 = require("./common-impl");
var common_types_1 = require("./common-types");
var configs_1 = require("../configs");
var AccountStore = require("./account.store");
var auth = require("../authProvider");
// -----------------
// STATE - This defines the type of data maintained in the Redux store.
var MessageActionTypes;
(function (MessageActionTypes) {
    MessageActionTypes["SUBMIT_STARTED"] = "MESSAGE_SUBMIT_STARTED";
    MessageActionTypes["SUBMIT_SUCCEEDED"] = "MESSAGE_SUBMIT_SUCCEEDED";
    MessageActionTypes["SUBMIT_FAILED"] = "MESSAGE_SUBMIT_FAILED";
    MessageActionTypes["CONTACTS_REQUEST_FAILED"] = "MESSAGE_CONTACTS_REQUEST_FAILED";
    MessageActionTypes["RESET_ISSENT"] = "MESSAGE_RESET_ISSENT";
})(MessageActionTypes || (MessageActionTypes = {}));
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.actionCreators = {
    sendMessage: function (values, targetPlatformId) { return function (dispatch, getState) {
        var appState = getState();
        if (!appState.messageSettings) {
            throw new Error('Failed to send message because there were no settings loaded');
        }
        if (appState && appState.message) {
            dispatch({ type: MessageActionTypes.SUBMIT_STARTED });
            var message = mapToMessage(values, targetPlatformId, appState);
            fetch(configs_1.BASE_API_URI + "/messages", {
                'headers': {
                    'x-api-key': configs_1.WRITE_API_KEY,
                    'Content-Type': 'application/json'
                },
                'method': 'POST',
                'body': JSON.stringify(message)
            })
                .then(common_impl_1.handleErrors)
                .then(function (response) { return response.json(); })
                .then(function (result) {
                var response = result;
                dispatch({ type: MessageActionTypes.SUBMIT_SUCCEEDED, result: response });
                // Update remaining sends in the account store
                dispatch({ type: AccountStore.AccountActionTypes.ACCOUNT_UPDATE_REMAINING_SENDS, remainingSends: response.remainingSends });
            })
                .catch(function (error) {
                if (error.text) {
                    error.text().then(function (errorText) {
                        return dispatch({
                            type: MessageActionTypes.SUBMIT_FAILED, error: errorText
                        });
                    });
                }
                else {
                    dispatch({
                        type: MessageActionTypes.SUBMIT_FAILED, error: configs_1.ERROR_GENERIC_MESSAGE
                    });
                }
            });
        }
    }; },
    resetIsSentFlag: function () { return function (dispatch, getState) {
        dispatch({ type: MessageActionTypes.RESET_ISSENT });
    }; },
    setMessageContactsRequestFailed: function (errorMsg) { return function (dispatch, getState) {
        dispatch({ type: MessageActionTypes.CONTACTS_REQUEST_FAILED, error: errorMsg });
    }; }
};
var mapToMessage = function (values, targetPlatformId, appState) {
    if (!appState.messageSettings || !appState.message) {
        throw new Error('Failed to send message because there were no settings loaded');
    }
    var message = {
        id: values.id,
        tenantId: auth.getTenantId(),
        type: common_types_1.ApiSubmitTypes.MESSAGE,
        targetPlatformId: targetPlatformId,
        mediumId: 'SMS',
        frequencyId: 'Once',
        sendDateTime: new Date().toISOString(),
        userId: auth.getEmail(),
        contact: {
            id: values.contactId ? values.contactId : null,
            tenantId: auth.getTenantId(),
            type: common_types_1.ApiSubmitTypes.CONTACT,
            firstName: values.firstName,
            lastName: values.lastName,
            mobilePhone: values.mobilePhone,
            dateCreated: appState.message.messageEntity.contact ? appState.message.messageEntity.contact.dateCreated : null
        },
        message: {
            body: configs_1.fillInsertedVariableValues(values.message, new configs_1.InsertableVariableValues(values.firstName, values.lastName)),
            footerLink: appState.messageSettings.messageSettingsEntity.targetPlatforms[0].messageFooterLink,
            footerText: configs_1.fillInsertedVariableValues(appState.messageSettings.messageSettingsEntity.targetPlatforms[0].messageFooter, new configs_1.InsertableVariableValues(values.firstName, values.lastName))
        }
    };
    switch (targetPlatformId) {
        case 'GMB':
            message.targetPlatformUri = appState.messageSettings.messageSettingsEntity.targetPlatforms[0].uri;
            break;
        case 'NON':
            break;
        default:
    }
    return message;
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    isLoading: false,
    messageEntity: {},
    error: null,
    isSent: false,
    result: {}
};
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case MessageActionTypes.SUBMIT_STARTED:
            return {
                isLoading: true,
                messageEntity: state.messageEntity,
                error: null,
                isSent: false,
                result: {},
            };
        case MessageActionTypes.SUBMIT_SUCCEEDED:
            return {
                isLoading: false,
                messageEntity: state.messageEntity,
                result: action.result,
                error: null,
                isSent: true,
            };
        case MessageActionTypes.SUBMIT_FAILED:
            return {
                isLoading: false,
                messageEntity: state.messageEntity,
                error: action.error,
                isSent: false,
                result: {},
            };
        case MessageActionTypes.RESET_ISSENT:
            return {
                isLoading: false,
                messageEntity: state.messageEntity,
                error: null,
                isSent: false,
                result: state.result,
            };
        case MessageActionTypes.CONTACTS_REQUEST_FAILED:
            return {
                isLoading: false,
                messageEntity: state.messageEntity,
                error: action.error,
                isSent: false,
                result: {},
            };
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=message.store.js.map